import * as React from 'react';
import ReactQuill from 'react-quill';
import { CaseForm } from "../components/CaseForm";
import { Row, Label, Col } from "reactstrap";
import { WrappedInput } from '../../../../share/components/Input/Input';
import { CheckCaseId } from '../../../../share/types/case/case';
import { Checkbox } from '../../../../share/components/Checkbox/Checkbox';
import { momentToString } from '../../../../share/utils/utils';
import { modules, formats } from '../../../../share/config/quill';
import 'react-quill/dist/quill.snow.css';

interface IProps { that: CaseForm }
export const CaseFormLayout = (props: IProps) => {
    return <AdvancedLayout  {...props} />;
}

const AdvancedLayout = (props: IProps) => (
    <Row className={"margin-forms"}>
        <Public {...props} />
        <Close {...props} />
        <Agency {...props} />
        <CaseId {...props} />
        <CaseType {...props} />
        <ContactInformation {...props} />
        <Poster {...props} />
        <OpenDate {...props} />
    </Row>
)
const Agency = ({ that }: IProps) => (
    <WrappedInput id="agencyCode" type="select" md={12} {...that.props.form('agencyCode', true)} onChange={that.onCaseIdChange('agencyCode')} disabled={that.props.isEditCase || that.props.disabled || !that.isAdmin()} labeltext={that.props.isEditCase ? 'Agency' : ''}>
        {that.isAdmin() && <option value="">Select One...</option>}
        {that.getAgenciesOptions()}
    </WrappedInput>
);
const ContactInformation = ({ that }: IProps) => (
    <div className="col-md-12 text-editor-contact">
        {that.props.isEditCase && <Label className="input-margin-top input-label">Contact Information</Label>}
        <ReactQuill
            modules={modules}
            formats={formats}
            {...that.contactInfoHandler('contactInformation')}
            placeholder="Contact Information"
            className="subFont"
        />
    </div>
)
const CaseId = ({ that }: IProps) => {
    const { form, caseInfo, disabled, isEditCase } = that.props;
    return (
        <WrappedInput invalid={that.props.caseIdStatus === CheckCaseId.Invalid} autocomplete="off" id="caseId" type="text" md={12}  {...form('caseId', true)} onChange={that.onCaseIdChange('caseId')} disabled={caseInfo.agencyCode === "" || isEditCase || disabled}
            subRender={that.getCaseStatusRender} prefix={caseInfo.agencyCode + "-"} placeholder={caseInfo.agencyCode ? "Type the case number" : "Select an agency first"} labeltext={that.props.isEditCase ? 'Case Id' : ''} />
    )
}
const Poster = ({ that }: IProps) => (
    <WrappedInput placeholder="Please type a poster title" id="poster" type="select" md={12} {...that.props.form('poster', false)} labeltext={that.props.isEditCase ? 'Poster' : ''}>
        <option value="Missing">Missing</option>
        <option value="Missing Child Alert">Missing Child Alert</option>
    </WrappedInput>
)
const OpenDate = ({ that }: IProps) => {
    const { form, caseInfo, disabled, isEditCase } = that.props;
    return disabled ? <> </> : isEditCase ? <Label className="label date-vertical-align">Open date: {momentToString(caseInfo.openDate)}</Label>
        : <WrappedInput placeholder="Open Date" type="date" md={12} {...form('openDate', true)} inputinfo="Must be in day/month/year format" />
}
const Close = ({ that }: IProps) => (
    <Col className="checkbox" md={5}>
        <Checkbox disabled={true} label={"Closed"} checked={that.props.caseInfo.status === "closed"} />
    </Col>
)
const CaseType = ({ that }: IProps) => (
    <WrappedInput type="select" md={12} placeholder="Case Type" {...that.props.form('caseType', true)} labeltext={that.props.isEditCase ? 'Case Type' : ''}>
        <option value="">Select One...</option>
        {that.getCaseTypeOptions()}
    </WrappedInput>
)
const Public = ({ that }: IProps) => (
    <Col className="checkbox float-right" md={7}>
        < Checkbox disabled={that.props.disabled} {...that.switchHandler('public')} label={"Public Access"} />
    </Col>
)